import { t } from "@lingui/core/macro";
import {isValidDate} from "./dateTimeUtils";

export function isEmail(email) {
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return re.test(String(email).toLowerCase());
};

export function isValidName(name, isRequired) {
    if(isRequired && isEmpty(name)) {
        return false;
    }

    const regexp = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return !regexp.test(name) && !name.includes("  ");
}

const getRequiredMessage = () => t({id: "this_field_is_required_please_fill"});

export function getNameError(name, isRequired) {
    if(isRequired && isEmpty(name)) {
        return getRequiredMessage();
    }

    if(!isRequired && isEmpty(name)) {
        return "";
    }

    const regexp = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return !regexp.test(name) && !name.includes("  ") ? "" : t({id: "letters_inly_no_double_spaces"});
}

export function getGenderError(gender) {
    return isEmpty(gender) ? getRequiredMessage() : "";
}

export function getDateError(date, minDate, maxDate) {
    return isValidDate(date, minDate, maxDate) ? "" :t({id: "please_enter_valid_date"});
}

export function getDocumentTypeError(documentType) {
    if(isEmpty(documentType) || documentType === "Select document type") {
        return t({id: "please_select_document_type"});
    }
    return "";
}

export function getDocumentNumberError(documentNumber) {
    return isEmpty(documentNumber) ? getRequiredMessage() : "";
}

export function getDropdownError(dropdownValue) {
    if(isEmpty(dropdownValue) || dropdownValue === "Please select") {
        return t({id: "please_select_a_valid_option"});
    }

    return "";
}

export function getPassportTCError(isChecked) {
    return isChecked ? "" : t({id: "please_confirm_passport_meets_requirements"});
}

export function getApisErrors(passengerData, getAllErrors, minMaxDates) {
    const errors = {};

    //validate terms and conditions accepted
    const termsError = getPassportTCError(passengerData.terms)
    if(termsError) {
        errors.terms = termsError;
        if(!getAllErrors) {
            return errors;
        }
    }

    //validate firstName
    const firstNameError = getNameError(passengerData.firstName, true);
    if(firstNameError) {
        errors.firstName = firstNameError;

        if(!getAllErrors) {
            return errors;
        }
    }

    //validate middleName
    const middleNameError = getNameError(passengerData.middleName, false);
    if(middleNameError) {
        errors.middleName = middleNameError;

        if(!getAllErrors) {
            return errors;
        }
    }

    //validate lastName
    const lastNameError = getNameError(passengerData.lastName, true);
    if(lastNameError) {
        errors.lastName = lastNameError;

        if(!getAllErrors) {
            return errors;
        }
    }

    // validate gender
    const genderError = getGenderError(passengerData.gender);
    if(genderError) {
        errors.gender = genderError;

        if(!getAllErrors) {
            return errors;
        }
    }


    // validate date of birth
    const dateOfBirthError = getDateError(passengerData.dateOfBirth);
    if(dateOfBirthError) {
        errors.dateOfBirth = dateOfBirthError;

        if(!getAllErrors) {
            return errors;
        }
    }
    
    // validate travel document type
    const documentTypeError = getDocumentTypeError(passengerData.documentType);
    if(documentTypeError) {
        errors.documentType = documentTypeError;

        if(!getAllErrors) {
            return errors;
        }
    }

    // validate document number
    const documentNumberError = getDocumentNumberError(passengerData.documentNumber);
    if(documentNumberError) {
        errors.documentNumber = documentNumberError;

        if(!getAllErrors) {
            return errors;
        }
    }

    // validate issue date
    const issueError = getDateError(passengerData.documentIssuedDate, minMaxDates.issueDateMin, minMaxDates.issueDateMax);
    if(issueError) {
        errors.documentIssuedDate = issueError;

        if(!getAllErrors) {
            return errors;
        }
    }


    // validate expiry date
    const expiryError = getDateError(passengerData.documentExpiryDate, minMaxDates.expiryDateMin, minMaxDates.expiryDateMax);
    if(expiryError) {
        errors.documentExpiryDate = expiryError;

        if(!getAllErrors) {
            return errors;
        }
    }

    // validate issuing country
    const documentCountryError = getDropdownError(passengerData.documentIssuanceCountry);
    if(documentCountryError) {
        errors.documentIssuanceCountry = documentCountryError;

        if(!getAllErrors) {
            return errors;
        }
    }

    // validate nationality
    const nationalityError = getDropdownError(passengerData.nationality);
    if(nationalityError) {
        errors.nationality = nationalityError;

        if(!getAllErrors) {
            return errors;
        }
    }

    return errors;
}

function isEmpty(value) {
    return !value;
}